 
<template>   
    <div class="modal fade" :id="modal" tabindex="-1" aria-hidden="true" >  
        <div class="modal-dialog" style="max-width:1700px;">  
            <div class="modal-content" style="min-height: 550px;">  
                <div class="modal-header"> 
					<h2>Atualizar</h2> 
					<div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal" >
						<span class="svg-icon svg-icon-1">
							<inline-svg src="media/icons/duotone/Navigation/Close.svg" />
						</span>
					</div> 
				</div> 
				<div class="modal-body scroll-y m-5"  >
                    <div class="row g-6 g-xl-12"   >  
                        <ListaCampoForm :campos="campos" :formulario="formulario"   ></ListaCampoForm>  
                    </div>  
				</div>  
                <div class="modal-footer"  > 
                    <BotaoSalvar  @click="salvar" :processando="processando" titulo="Atualizar"></BotaoSalvar>   
				</div> 
			</div> 
		</div> 
	</div> 
</template>

<script lang="ts">
	  
    import BotaoSalvar from '@/components/aplicacao/BotaoSalvar.vue';
    import ListaCampoForm from '@/components/aplicacao/ListaCampoForm.vue'; 
    import { Options, Vue  } from "vue-class-component";  
    import   SiteUtils   from '@/assets/ts/aplicacao/site';
    import {  Prop  , Watch } from 'vue-property-decorator';   
	 
     
    @Options({
        name: "ModeloUpdate",
        components: {  ListaCampoForm, BotaoSalvar },   
    }) 
    export default class ModeloUpdate extends Vue {
 
        @Prop( ) readonly modal!: any 
        @Prop( ) readonly perfis!: any  
        @Prop( ) readonly service!: any
        @Prop( ) readonly modelo!: any
        
         
        public processando = false;  
        public formulario: any  = { } ;  
        public campos: Array<any> = [ ];
 
        public modeloAlterado(){  
            console.log('atualizando');
        }

        @Watch('modelo')
		modeloAtualizada(newVal: string) { 
            this.modeloAlterado(); 
		}
 
        get hasPermissao(   ): boolean {
            return false; 
        }
   
        
 
        public sucesso(){  
            console.log('sucesso');
        }

        
        public getdados(){  
            let dados = JSON.parse(JSON.stringify(this.formulario)); 
            return dados;
        }

        public salvar(){
            if( this.processando  ||  !this.hasPermissao ){
                return;
            }
            this.processando = true ;  
            let dados = this.getdados() ;  
            setTimeout(() => {  
                this.service.update(  this.modelo.id, dados )
                .then(response => { 
                    SiteUtils.toastSucesso('Atualizado com sucesso! ' ,  response.message  );
                    this.sucesso();  
                    this.formulario = {};
                    this.processando = false ;  
                }) 
                .catch(error => {
                    this.processando = false ;
                    SiteUtils.toastErro('Error! ' ,  error.data.message  );
                });  
            }, 100); 
        }  
    }    
</script>
 
<style scoped> 
    .btn-sm{
        margin-left: 10px; 
    }
    .registro-alteracao{
        text-align: right;
    }

</style>